import type { RequestAddonQuoteEpicApi } from 'epic/postTradeOperations/addon/requestAddonQuoteEpic';
import type { QuoteAck } from 'models/quote/QuoteAck';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http.old/httpClient.model';

export function addonQuoteRequestApi(http: IHttpClient): RequestAddonQuoteEpicApi {
  return {
    requestQuote(payload) {
      return http.post<QuoteAck>({ url: 'api/v1/addon/quote', body: payload }).pipe(map(r => r.payload));
    },
  };
}
